/**
 * How many leads a form's run covers, as far as the form can know it (PREC-4263 review S1): none
 * (the run does nothing, so there is nothing to quote), a count (the rows it submits, or the
 * table's total for a run the server resolves from the table's view), or unknown (the server
 * resolves leads the form has no count of). Unknown is never 0: the cost is shown as decided by
 * the run, so a run on every lead of a list is not presented as free.
 */
export type RunScope = { kind: "none" } | { kind: "count"; count: number } | { kind: "unknown" };

export const NO_RUN: RunScope = { kind: "none" };
export const UNKNOWN_RUN: RunScope = { kind: "unknown" };

/** A run on `count` leads; on none when the count is 0. */
export const runOn = (count: number): RunScope => (count > 0 ? { kind: "count", count } : NO_RUN);
